// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type SupportAgent48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const SupportAgent48: FC<SupportAgent48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
            viewBox="0 0 48 48"
        >
            <path d="M22.047 42v-3h17V23.8q0-6.184-4.366-10.492T24.047 9q-6.267 0-10.634 4.308Q9.047 17.616 9.047 23.8V36h-1q-1.65 0-2.825-1.175T4.047 32v-4q0-1.05.525-1.975a3.9 3.9 0 0 1 1.475-1.475l.15-2.65q.4-3.4 1.975-6.3a19 19 0 0 1 3.95-5.05 17.6 17.6 0 0 1 5.45-3.35Q20.647 6 24.047 6t6.45 1.2 5.45 3.325a18 18 0 0 1 3.95 5.025q1.55 2.9 2 6.3l.15 2.6q.95.45 1.475 1.35t.525 1.9v4.6q0 1-.525 1.9t-1.475 1.35V39q0 1.237-.88 2.118a2.9 2.9 0 0 1-2.12.882zm-4.009-14.5a1.43 1.43 0 0 1-1.066-.434 1.48 1.48 0 0 1-.425-1.075q0-.641.434-1.066a1.48 1.48 0 0 1 1.075-.425q.641 0 1.066.434.425.433.425 1.075t-.434 1.066a1.48 1.48 0 0 1-1.075.425m12 0a1.43 1.43 0 0 1-1.066-.434 1.48 1.48 0 0 1-.425-1.075q0-.641.434-1.066a1.48 1.48 0 0 1 1.075-.425q.641 0 1.066.434.425.433.425 1.075t-.434 1.066a1.48 1.48 0 0 1-1.075.425m-17.94-2.6q-.351-5.3 3.2-9.1 3.549-3.8 8.85-3.8 4.35 0 7.55 2.875 3.199 2.875 3.9 7.175-4.452-.05-8.126-2.5-3.675-2.45-5.689-6.45a15.83 15.83 0 0 1-3.36 7.125 16 16 0 0 1-6.326 4.675" />
        </svg>
    );
};

export default SupportAgent48;
